import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { FormControl } from '@angular/forms';
import { startWith, debounceTime, map, filter, takeUntil } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { SpecialFormControl } from '@utilities/SpecialForms';
import { ControlFormsService } from '@services/control-forms.service';
import { Subject } from 'rxjs';

export interface DataList {
  id: string;
  element: string;
}

// dev 7.0

@Component({
  selector: 'app-pick-table',
  templateUrl: './pick-table.component.html',
  styleUrls: ['./pick-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class PickTableComponent implements OnInit {

  // Elementos a seleccionar
  @Input('data') 
  set leftListBase( lista: DataList[] ) {
    lista.sort( (a,b) => {
        if (a.element.trim() > b.element.trim()) {
          return 1;
        }
        if (a.element.trim() < b.element.trim()) {
          return -1;
        }
        return 0;
      } 
    );
    this.inputArray = [...lista];
    this.inputProcessor();
  }

  // Cadena de texto con elementos separados por coma
  @Input('dataSelected') 
  set dataTextInput(list: string) {
    this.inputString = list;
    this.inputProcessor();
  }


  @Input("sfControlData")
  set sfControlData(control: SpecialFormControl) {
    this.sfControlData2 = control;
    let value = this.sfControlData2.value;
    if(value){
      let keys = value.split(",");
      if(keys){
        this.requirementsSelected = keys;
      }
    }
  }


  // Emite la lista de elementos seleccionados
  @Output() selectedItems = new EventEmitter<string>();

  public searchField = new FormControl('');

  public inputString: string;

  public inputArray: DataList[] = [];

  leftList: DataList[] = [];

  leftListShow: DataList[] = [];

  rightList: DataList[] = [];

  public sfControlData2: SpecialFormControl;

  public requirementsSelected: string[] = [];

  private _finisher = new Subject<void>();

  @Input() hidding: boolean = false;

  constructor(
    private _controlFormsService: ControlFormsService,
  ) {

    this._controlFormsService.itemValuePickList.pipe(takeUntil(this._finisher)).subscribe((nextValue) => {
      if(!nextValue){
        this.hidding = true;
        this.searchField.disable();
      }
    });

    
    
  }

  ngOnInit() {
    

    this.searchField.valueChanges
      .pipe(
        debounceTime( 200 )
      ).subscribe( item => {
          if (item) {
            this.leftListShow = this.leftList.filter( i => i.element.includes( item.toUpperCase() ) );  
          } else {
            this.leftListShow = [...this.leftList];
          }
          
        } 
      );

  }

  private inputProcessor() {
    if (this.inputArray.length > 0 ) {
      this.leftList = [...this.inputArray];
      this.leftListShow = [...this.leftList];
      if (this.inputString) {
        this.rightList = this.processSelectedItemsInput(this.inputString, this.leftList);
        this.deleteItemsLeftList();        
      }
    }
  }


  // this.processSelectedTeachersInput(datos, this.data) )
  movData( entryList: MatSelectionList, add: boolean ) {
    const elements: MatListOption[] = entryList.selectedOptions.selected;
    if (add) {
      this.auxMovData(elements, this.leftList, this.rightList);
    } else {
      this.auxMovData(elements, this.rightList, this.leftList );
    }
    this.selectedItems.emit( this.processSelectedItemsOutput(this.rightList) );
    this.searchField.reset();
  }

  private auxMovData( dataEntry: MatListOption[], source: DataList[], target: DataList[] ) {
    dataEntry.forEach( item => {
      const idData = item.value as string;
      const name = item.getLabel() as string;
      const data: DataList = {id: idData, element: name};
      target.push(data);
      const indexItemDelete = source.findIndex( elemento => elemento.id === idData);
      source.splice(indexItemDelete, 1);
    });
  }

  private deleteItemsLeftList() {
    if ( this.rightList && this.rightList.length > 0 ) {
      for (const item of this.rightList) {
        const indexItemDelete = this.leftList.findIndex( elemento => elemento.id === item.id);
        this.leftList.splice(indexItemDelete, 1);
      }
    }
  }

  private processSelectedItemsOutput(inputData: DataList[]): string {
    if (inputData.length > 0) {
      return inputData.map( i => i.id ).join();
    }
    return '';
  }

  // Convierte los elementos de texto de entrada en
  // un arreglo de DataList para ser desplegados
  // en la lista derecha
  private processSelectedItemsInput(inputData: string, teacherList: DataList[]): DataList[] {
    const result: DataList[] = [];
    if (inputData && inputData.length > 0) {
      const arrayText = inputData.split(',');
      arrayText.map( i => {
        const element: DataList = teacherList.find(t => t.id === i);
        if (element) {
          result.push(element);
        }
      });
    }
    return result;
  }

  compareFn(o1: any, o2: any) {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  onSelection(v){
    let arraySelected = v.selected.map(item => item.value);
    this.selectedItems.emit(arraySelected.join());
 }

}
